import React, { useEffect, useState } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import {
  useAddProcessingEveningEmployeeMutation,
  useAddProcessingMorningEmployeeMutation,
  useUpdateProcessingMorningEmployeeMutation,
} from "./processingWashingApi";
import { useUpdateEveningEmployeeMutation } from "../../ripening/washing/washingApi";
import useTranslator from "../../../hooks/useTranslator";

const WashingModal = ({ show, setShow, employee, mode }) => {
  const [addMorningEmployee, { isLoading: isMorning }] =
    useAddProcessingMorningEmployeeMutation();
  const [addEveningEmployee, { isLoading: isEvening }] =
    useAddProcessingEveningEmployeeMutation();
  const [editMorningEmployee] = useUpdateProcessingMorningEmployeeMutation();
  const [editEveningEmployee] = useUpdateEveningEmployeeMutation();
  const getCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} `;
  };
  const initialFormData = {
    date: getCurrentTime(),
    emp_total: "",
    orange_cases: "",
    red_cases: "",
    yellow_cases: "",
    carts: "",
    treys: "",
    knifes: "",
    bowls: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if ((mode === "editMorning" || mode === "editEvening") && employee) {
      setFormData(employee); // assuming `employee` is the existing data object
    } else {
      setFormData(initialFormData);
    }
  }, [mode, employee, show]);
  const mutationMap = {
    addMorning: addMorningEmployee,
    addEvening: addEveningEmployee,
    editMorning: editMorningEmployee,
    editEvening: editEveningEmployee,
  };
    const { _t } = useTranslator();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const selectedMutation = mutationMap[mode];
      if (!selectedMutation) throw new Error("Unknown mode");

      const payload = mode.startsWith("edit")
        ? { id: employee?.id, requestBody: formData }
        : formData;

      await selectedMutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const renderFormFields = () => {
    if (mode === "addMorning" || mode === "editMorning") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employee", "Total Employee")}
              placeholder={"0"}
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("orange_cases", "Orange Cases")}
              placeholder={"0"}
              type="number"
              name="orange_cases"
              value={formData.orange_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("red_cases", "Red Cases")}
              placeholder={"0"}
              type="number"
              name="red_cases"
              value={formData.red_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("yellow_cases", "Yellow Cases")}
              placeholder={"0"}
              type="number"
              name="yellow_cases"
              value={formData.yellow_cases}
              onChange={handleChange}
            />
          </Col>
        </>
      );
    } else if (mode === "addEvening" || mode === "editEvening") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label="Date"
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employee", "Total Employee")}
              placeholder={"0"}
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("carts", "Carts")}
              placeholder={"0"}
              type="number"
              name="carts"
              value={formData.carts}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("trey", "Trey")}
              placeholder={_t("trey_placeholder", "Trey...")}
              type="number"
              name="treys"
              value={formData.treys}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("knifes", "Knifes")}
              placeholder={"0"}
              type="number"
              name="knifes"
              value={formData.knifes}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("bowls", "Bowls")}
              placeholder={"0"}
              type="number"
              name="bowls"
              value={formData.bowls}
              onChange={handleChange}
            />
          </Col>
        </>
      );
    }
  };
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "addMorning" || mode === "editMorning"
          ? _t("morning_shift", "Morning Shift")
          : _t("evening_shift", "Evening Shift")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            isLoading={"isCreating" || "isUpdating"}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default WashingModal;
